module.exports = __webpack_public_path__ + "img/icon-livelo-purple.74cd3cba.svg";